import type { ThumbnailImage } from "@videojs/core";

function parseVttTime(value: string): number | null {
  const parts = value.trim().split(":");
  if (parts.length < 2 || parts.length > 3) return null;
  const seconds = Number(parts.pop());
  const minutes = Number(parts.pop());
  const hours = parts.length > 0 ? Number(parts.pop()) : 0;
  if (![seconds, minutes, hours].every(Number.isFinite)) return null;
  return hours * 3600 + minutes * 60 + seconds;
}

/** Shared parser for the Video.js player and admin retention preview. */
export function parseStoryboardVtt(vtt: string, baseUrl: string): ThumbnailImage[] {
  const lines = vtt.replace(/\r/g, "").split("\n");
  const thumbnails: ThumbnailImage[] = [];

  for (let index = 0; index < lines.length; index += 1) {
    const line = lines[index]?.trim();
    if (!line || !line.includes("-->")) continue;

    const [startValue, endAndSettings] = line.split("-->");
    const endValue = endAndSettings?.trim().split(/\s+/)[0];
    const startTime = parseVttTime(startValue ?? "");
    const endTime = parseVttTime(endValue ?? "");
    if (startTime == null || endTime == null) continue;

    let cueText = "";
    for (let cueIndex = index + 1; cueIndex < lines.length; cueIndex += 1) {
      const candidate = lines[cueIndex]?.trim() ?? "";
      if (!candidate) break;
      cueText = candidate;
      index = cueIndex;
      break;
    }
    if (!cueText) continue;

    const [rawUrl, rawFragment] = cueText.split("#");
    const image: ThumbnailImage = {
      url: new URL(rawUrl ?? "", baseUrl).href,
      startTime,
      endTime
    };
    const xywh = /^xywh=(\d+(?:\.\d+)?),(\d+(?:\.\d+)?),(\d+(?:\.\d+)?),(\d+(?:\.\d+)?)$/.exec(
      rawFragment ?? ""
    );
    if (xywh) {
      const [, x, y, width, height] = xywh.map(Number);
      image.coords = { x, y };
      image.width = width;
      image.height = height;
    }
    thumbnails.push(image);
  }

  return thumbnails;
}
